<template>
	<div id="sizehelper" class="position-absolute" style="left: 0; top: 0; z-index: 100; background-color: #e6dbb9; width: 30px; height: 30px;">
		<div class="d-flex align-middle justify-content-center align-items-center w-100 h-100">
			<span class="text-small d-block d-sm-none">XS</span>
			<span class="text-small d-none d-sm-block d-md-none">SM</span>
			<span class="text-small d-none d-md-block d-lg-none">MD</span>
			<span class="text-small d-none d-lg-block d-xl-none">LG</span>
			<span class="text-small d-none d-xl-block d-xxl-none">XL</span>
			<span class="text-small d-none d-xxl-block">XXL</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "SizeHelper"
}
</script>

<style scoped>

</style>